export const patientsAr = {
  "Consultations": "الاستشارات", 
  "Patients En cours": "المرضى الذين يخضعون للعلاج", 
  "Patients Terminé": "المرضى الذين أنهوا العلاج", 
  
  "DOSS.NO": "المجلد الرقم",
  "WhatsApp": "الواتساب",
  "Balance": "الرصيد",
  "Chercher par Doss.NO": "البحث عن طريق رقم المجلد",
  "Chercher par nom": "البحث عن طريق الإسم",
  "Chercher par numero telephone": "البحث عن طريق رقم الهاتف",
  "Non Archivé": "الغير مؤرشفة",
  "Archivé": "الأرشيف",
  "Patients": "المرضى",
  "Patients en commun": "المرضى المشتركون",
  "Débiteur": "المدين",
  "Régulariser": "المنتظمين",
  "Créancier": "الدائنين",

  "Nom du patient": "اسم المريض",
  "Numero de telephone": "رقم الهاتف",
  "Address du patient": "عنوان المريض",
  "Address": "العنوان",
  "Année de naissance": "سنة الميلاد",
  "Etat de Santé": "الحالة الصحية",
  
  
  "Ajouter": "إضافة",
  "Modifier": "تحرير",
  "Supprimer": "حذف",
  "Passer": "تخطى",
  "Retourner": "اعادة",
  "Terminer": "انهاء",
  "Envoyer": "ارسال",
  "Fermer": "اغلاق",
  "Prise en charge": "الرعاية الطبية",

  "Assuré": "مؤمن من طرف",
  "Matricule Professionel": "الرقم المهني",
  "Pourcentage couvré par la societé": "النسبة التي تغطيها الشركة",

  /** START DEVIS  */
  "Traitement": "العلاج",
  "Dents": "الأسنان",
  "Surface": "المساحة",
  "NBS": "العدد",
  "Prix.U": "السعر",
  "Total": "المجموع",
  "Reduction": "التخفيض",
  "Reste": "الباقي",

  "Ajouter un traitment pour creer un devis": "أضف علاجًا لإنشاء خطة علاج",
  "Actions": "أجراءات",
  
  "Nom du traitement": "اسم العلاج",
  "Choisir les traitments du cabinet": "اختر علاجات العيادة",
  "Donner la reduction en pourcent": "أعط التخفيض كنسبة مئوية",
  "Qty": "الكمية",
  "Dents Pediatre": "اسنان اطفال",

  /** END DEVIS  */

  /** START Fiche  */
  
  "Date": "التاريخ",
  "Actes": "الأجراءات",
  "Montant": "المبلغ",
  "Facture": "فاتورة",
  "RDV": "موعد",
  
  /** END Fiche  */


  /** START INvoices */

  "global": "الكل",
  "cabinet": "العيادة",
  
  "Payé par l'Assurance": "تم دفعه عن طريق التأمين",
  "Payé par le patient": "تم دفعها من قبل المريض",
  
  /** END INvoices */
  
  "Laboratoire": "المختبر",
  "Mode de paiement": "طريقة الدفع",
  "Status": "الحالة",
  "Reste du devis": "الباقي من خطة علاج",
  "Age": "العمر",

  /** START Bar navigation of manage patient **/
  
  "Devis": "خطة علاج",
  "Factures": "الفواتير",
  "Labo": "المختبر",
  "Paiements": "المدفوعات",
  "Pay Assuré": "مدفوعات التأمين",
  "Soins": "علاجات",
  "Fiches": "استمارات البيانات",
  "Fiche": "استمارة",
  
  /** END Bar navigation of manage patient **/


  // Server Side 
  "Donner une reduction valide": "إعط خصم صالح",
  "Le traitement a ete fait vous ne pouvez plus le supprimer.": "تم بالفعل العمل بهذا العلاج، ولم يعد بإمكانك حذفها.",
  "la dernière facture n'est pas encore clôturé": "الفاتورة الأخيرة لم تغلق بعد",
  "La facture ne peut pas être supprimée car elle est déjà remplie": "لا يمكن حذف الفاتورة لأنها مملوءة بالفعل",

  "Le doctor est obligatoire.": "اختيار الطبيب إلزامي",
  "Le nom du patient est obligatoire.": "اسم المريض مطلوب.",
  "Le telephone du patient est obligatoire.": "مطلوب رقم هاتف المريض.",
  "Année de naissance du patient est obligatoire.": "مطلوب سنة ميلاد المريض.",
  "Choisir societe d'assurance.": "اختر شركة التأمين.",
  "Donner le matricule.": "إعطاء رقم التسجيل.",
  "Donner la prise en charge.": "اعطي دعم الرعاية",
  "Donner le pourcentage.": "أعط النسبة.",

  "Donner le montant": "أعط المبلغ",
  "Le patient est assuré par une societe que vous n'avez pas encore creer sa facture": "يتم التأمين على المريض من قبل شركة لم تقم بإنشاء فاتورتها بعد",
  "Veuillez creer une facture pour cette societe d'assurance": "يرجى إنشاء فاتورة لشركة التأمين هذه",


}

